if (
  document.URL.match(/edit_profile/) ||
  document.URL.match(/update_profile/) ||
  document.URL.match(/profile/) ||
  document.URL.match(/create_profile/)
) {
  document.addEventListener("DOMContentLoaded", function () {
    const button_start_time_date = document.getElementById(
      "start_time_input_button"
    );
    const button_start_times = document.querySelectorAll(".start_time");
    const input_start_time_date = document.getElementById("start_time_date");
    button_start_time_date.addEventListener("click", function () {
      input_start_time_date.classList.remove("d-none");
    });
    button_start_times.forEach(function (button_start_time) {
      button_start_time.addEventListener("click", function () {
        input_start_time_date.classList.add("d-none");
      });
    });
  });
}
